import { CountryCode } from '@dayetopia/types';
import { TFunction } from '@contracts';
import useReplacedTranslate from './useReplacedTranslate';

export default function useTranslate(country?: CountryCode): { t: TFunction } {
  const { t } = useReplacedTranslate(country);

  return {
    t
  };
}
